import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { RawLink } from '@/shared/ui/RawLink'

export interface SettingsListItemProps {
    icon: ReactNode
    name: string
    onClose: () => void
    link: string
}

export const SettingsListItem = ({
    icon,
    name,
    onClose,
    link,
}: SettingsListItemProps) => {
    const container = {
        padding: '12px',
        display: 'flex',
        cursor: 'pointer',
        color: 'white',
    }
    const nameStyle = {
        typography: 'label3',
        lineHeight: '20px',
    }

    return (
        <RawLink to={link} onClick={onClose} dataTestId="SearchVodItemLink">
            <Box sx={container}>
                <Box paddingRight="12px">{icon}</Box>
                <Typography sx={nameStyle}>{name}</Typography>
            </Box>
        </RawLink>
    )
}
